import { useNextOrderV3, useGetOrder } from '@hungryroot/orders';
import { useCartSelf } from '../hooks/useCartSelf';

export function useCartInitialization(enabled: boolean) {
  // the is_shuffling flag for this endpoint doesn't get calculated so currently it's always false
  // but should be null https://hungryroot.atlassian.net/browse/BE-2220
  const { order: nextOrder } = useNextOrderV3();

  const { data: order } = useGetOrder(nextOrder?.id, {
    enabled,
  });

  const cartResult = useCartSelf({
    enabled: order?.is_shuffling === false,
    inventoryDate: order?.inventory_date ?? undefined,
  });

  return cartResult;
}
